export const GET_EXAM_INSTRUCTION_REQUEST = "GET_EXAM_INSTRUCTION_REQUEST";
export const GET_EXAM_INSTRUCTION_SUCCESS = "GET_EXAM_INSTRUCTION_SUCCESS";
export const GET_EXAM_INSTRUCTION_FAIL = "GET_EXAM_INSTRUCTION_FAIL";

export const MOCK_EXAM_QUESTIONS_REQUEST = "MOCK_EXAM_QUESTIONS_REQUEST";
export const MOCK_EXAM_QUESTIONS_SUCCESS = "MOCK_EXAM_QUESTIONS_SUCCESS";
export const MOCK_EXAM_QUESTIONS_FAIL    = "MOCK_EXAM_QUESTIONS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
